import { UpdateComplianceItemArgs } from '@commenda/types/src/compliance-calendar/compliances/types';
import { fetcher } from '@commenda/utils';

interface UpdateComplianceItemResponse {
  success: boolean;
}

export async function updateComplianceItem(
  complianceItemId: string,
  body: UpdateComplianceItemArgs,
  nextAuthToken?: string
): Promise<UpdateComplianceItemResponse> {
  const res = await fetcher(`compliance/${complianceItemId}`, {
    method: 'POST',
    body,
  });

  if (!res.ok) {
    return {
      success: false,
    };
  }
  return {
    success: true,
  };
}
